import React, { useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import {
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Typography,
    Grid,
    TextField,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import useFormHandlers from "../useFormHandlers";
import SettingsResetButton from "../SettingsResetButton";
import { useStyles } from "../styles";

const smsSettingsValidationSchema = Yup.object().shape({
    smsreceipttemplate: Yup.string()
        .max(2000, "Maximum of 2000 characters"),
});

const SMSSettingsForm = ({
    entityID,
    entityType,
    settingValues,
    settingValuesParent
}) => {
    const classes = useStyles();
    const [smsSettingsExpanded, setSMSSettingsExpanded] = useState(true);

    const toggleSMSSettingsExpanded = () => {
        setSMSSettingsExpanded(!smsSettingsExpanded);
    };

    const {
        control,
        watch,
        setValue,
        formState: { errors },
    } = useForm({
        mode: "onChange",
        resolver: yupResolver(smsSettingsValidationSchema),
        defaultValues: {
            smsreceipttemplate: settingValues.smsreceipttemplate,
        },
    });

    const watchFields = watch();

    const { handleInputChange, handleResetChange } = useFormHandlers(
        setValue,
        settingValues,
        entityID,
    );

    return (
        <Grid container className={classes.panelRoot}
            data-testid="sms-settings-panel">
            <Accordion
                data-tag="smsSettings"
                expanded={smsSettingsExpanded}
                TransitionProps={{
                    unmountOnExit: true,
                }}
                className={classes.fullWidthAccordion}
            >
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    onClick={toggleSMSSettingsExpanded}
                    data-testid="sms-accordion-summary"
                >
                    <Typography className={classes.heading}>
                        SMS
                    </Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={8}>
                            <Controller
                                name="smsreceipttemplate"
                                control={control}
                                render={({ field }) => (
                                    <TextField
                                        {...field}
                                        variant="outlined"
                                        className={classes.withReset}
                                        fullWidth
                                        id="smsreceipttemplate"
                                        label="Receipt SMS Template"
                                        multiline
                                        rows={4}
                                        onBlur={e => handleInputChange(errors, e)}
                                        error={!!errors.smsreceipttemplate}
                                        helperText={errors.smsreceipttemplate && errors.smsreceipttemplate.message}
                                        FormHelperTextProps={{
                                            'data-testid': `${field.name}-helper-text`
                                        }}
                                    />
                                )}
                            />
                            <SettingsResetButton
                                entityID={entityID}
                                entityType={entityType}
                                settingName="smsreceipttemplate"
                                currentValue={watchFields.smsreceipttemplate}
                                originalValue={settingValuesParent.smsreceipttemplate}
                                onClick={() => {
                                    handleResetChange(
                                        "smsreceipttemplate",
                                        settingValuesParent.smsreceipttemplate
                                    );
                                }}
                            />
                        </Grid>
                    </Grid>
                </AccordionDetails>
            </Accordion>
        </Grid>
    );
};

SMSSettingsForm.defaultProps = {
    settingValues: {},
};

export default SMSSettingsForm;
